<template>
    <div>
        <header-slot>
            <template v-slot:content-right>
                <b-button v-b-tooltip.hover.left="'Solicitar Aumento de Sueldo'"
                    v-ripple.400="'rgba(40, 199, 111, 0.15)'" variant="outline-success" class="mr-1"
                    @click="solicitarAumentoSueldo">
                    <div class="d-flex justify-content-between">
                        <tabler-icon icon="CashIcon" class="mr-1" />
                        <span>Solicitar</span>
                    </div>
                </b-button>

            </template>
        </header-slot>

        <b-nav card-header pills class="m-0">
            <b-nav-item v-for="(tab, index) in tabs" :key="index" :to="{ name: tab.name }" exact
                :class="isActiveTab(index)" exact-active-class="active" :link-classes="['px-3', bgTabsNavs]">{{
                tab.title }}</b-nav-item>
        </b-nav>


        <b-card no-body class="border-top-primary border-3 border-table-radius px-0">
            <router-view ref="routerViewTab" :key="routeName" />
        </b-card>
    </div>
</template>


<script>
import Ripple from "vue-ripple-directive";

export default {
    components: {},
    directives: {
        Ripple
    },
    data() {
        return {
            varPrueba: false,
        };
    },
    created() { },
    computed: {
        tabs() {
            return this.$route.matched[1].meta.tabs;
        },
        routeName() {
            return this.$route.matched[2].name;
        },

    },
    methods: {
        isActiveTab(tab) {
            if (tab == 0 && this.routeName == 'rrhh-aumento-sueldo-solicitudes') {
                return true;
            }
            return false;
        },
        solicitarAumentoSueldo() {
            this.$refs['routerViewTab'].solicitarAumentoSueldo();
        }
    }
};
</script>